export default __webpack_public_path__ + "static/media/mohit.1d227061.png";